import { formatFamilyName } from "./formatFamilyName";
import { formatGroupTitle } from "./formatGroupTitle";
import { getDirectoryLink } from "../utilities/getDirectoryLink";
import { getGroupPageLink } from "../utilities/getGroupPageLink";
export function renderGroups(groups) {
    const groupsContainer = document.querySelector(".groups-row");
    let html = "";
    Object.keys(groups)
        .sort()
        .forEach((groupKey) => {
        const group = groups[groupKey];
        if (group.length) {
            html += `
                    <div class="groups-grid">
                        <h4 class="group-title">
                            <a href="${getGroupPageLink(groupKey)}" class="group-link" id="${groupKey}">
                                ${formatGroupTitle(groupKey)}
                                
                                <div class="copy-group-emails" title="Group information">
                                    <span class="icon fas fa-info"></span>
                                </div>  
                            </a>
                        </h4>
                        <ul class="groups-row__people">
                `;
            group
                .sort((a, b) => {
                const textA = a["family-name"].toUpperCase();
                const textB = b["family-name"].toUpperCase();
                return textA < textB ? -1 : textA > textB ? 1 : 0;
            })
                .forEach((family) => {
                const familyName = family["family-name"];
                const Leader = family.members.filter((member) => member.groups.indexOf("Deacons") > -1 ||
                    member.groups.indexOf("Elders") > -1);
                const className = Leader.length
                    ? ' class="group-leader"'
                    : "";
                html += `<li${className}>
                            <a href="${getDirectoryLink(family["family-id"], familyName)}" title="Directory listing for ${familyName}">
                                <span class="fa-solid fa-address-book"></span>
                                ${formatFamilyName(familyName)}
                            </a>
                        </li>`;
            });
            html += `
                        </ul>
                    </div>
                `;
        }
    });
    if (html.length) {
        groupsContainer.innerHTML = html;
    }
    else {
        groupsContainer.innerHTML = "Sorry, couldn't find a match.";
    }
}
